import React from 'react'

const Logout = props => (
  <svg width={24} height={24} viewBox="0 0 24 24" {...props}>
    <path
      fill={props.fill || '#1A344F'}
      fillRule="evenodd"
      d="M12.984 0C19.059 0 24 4.935 24 11s-4.942 11-11.017 11c-2.393 0-4.667-.752-6.578-2.176l.01-.015A.984.984 0 015.974 19c0-.552.449-1 1.002-1 .238 0 .447.095.619.233l.008-.012A8.95 8.95 0 0012.984 20c4.97 0 9.014-4.038 9.014-9s-4.044-9-9.014-9a8.941 8.941 0 00-5.378 1.777l-.01-.012a.988.988 0 01-.62.235 1 1 0 01-1.002-1c0-.343.185-.631.449-.811l-.012-.016A10.931 10.931 0 0112.984 0zM7.01 6c.275 0 .526.112.708.293l4.006 3.999a1.01 1.01 0 01.216 1.092 1.004 1.004 0 01-.202.303l-.014.021-4.006 3.999A1.003 1.003 0 016.01 15a.99.99 0 01.293-.708L8.6 12H1.002a1 1 0 110-2h7.596L6.303 7.708l-.085-.097A1 1 0 017.01 6z"
    />
  </svg>
)

export default Logout
